module.exports = __webpack_public_path__ + "img/health-mission-solid.30f3347d.svg";